/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import CountUp from "react-countup";

export default function Statistics() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);
    const [statistics, setStatistics] = useState([]);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.3 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    useEffect(() => {
        fetch("https://ligasos-laravel.ligasos.co/api/statistics")
            .then((response) => response.json())
            .then((data) => setStatistics(data))
            .catch((error) => console.error("Error fetching statistics:", error));
    }, []);

    return (
        <section ref={sectionRef} className="py-[40px]">
            <div className="container flex flex-col gap-[20px]">
                <div className="flex flex-wrap justify-center">
                    {statistics.map((stat, index) => {
                        const numericValue = parseFloat(stat.value.replace(/[^0-9.]/g, ""));
                        const suffix = stat.value.replace(/[0-9,.]/g, "").trim();

                        return (
                            <div
                                key={stat.id}
                                className={`w-full sm:w-[25%] py-[60px] px-[20px] border-[1px] border-[#eee] flex flex-col items-center gap-[10px]`}
                            >
                                <div className="flex flex-col items-center">
                                    <div className="font-bold capitalize text-[35px]">
                                        {isVisible ? (
                                            <CountUp
                                                end={isNaN(numericValue) ? 0 : numericValue}
                                                duration={6}
                                                suffix={suffix}
                                                decimals={suffix === "BN" ? 1 : 0}
                                            />
                                        ) : (
                                            stat.value
                                        )}
                                    </div>
                                    <div className="capitalize text-center">{t(stat.title)}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}